'use strict';

var button = require('../../../../../../../../../../_virtual/button3.cjs');

(function (exports) {

	exports.ButtonAviaryVariants = void 0;
	(function(ButtonAviaryVariants) {
	    ButtonAviaryVariants["primary"] = "primary";
	    ButtonAviaryVariants["secondary"] = "secondary";
	    ButtonAviaryVariants["tertiary"] = "tertiary";
	})(exports.ButtonAviaryVariants || (exports.ButtonAviaryVariants = {}));
	
} (button.__exports));
//# sourceMappingURL=button.cjs.map
